import { GET_SECTIONS } from "constants/sections";

export default (state = [], action) => {
  switch (action.type) {
    case `${GET_SECTIONS}_SUCCESS`:
      return action.payload;
    default:
      return state;
  }
};
